// extracted by mini-css-extract-plugin
module.exports = {"greenBackGround":"Paylink-module__greenBackGround","remainingCardContainer":"Paylink-module__remainingCardContainer","remainingContainer":"Paylink-module__remainingContainer"};